import { createApiClient } from "./generated/api";

export const AtlasApiClient = createApiClient("/api/atlas");
